// import PropTypes from 'prop-types'
// import React, { Component } from 'react'
import { userData } from '../../data/userData';


import {
    FaLinkedin,
    FaGithub,
    FaEnvelope
} from 'react-icons/fa';

interface SocialsProps {
    color: string;
}

function Socials(props: SocialsProps) {

  return  (
            <>
                {userData.linkedIn && (
                    <a
                        href={userData.linkedIn}
                        target='_blank'
                        rel='noreferrer'
                    >
                        <FaLinkedin
                            className='landing--social'
                            style={{ color: props.color }}
                            aria-label='LinkedIn'
                        />
                    </a>
                )}
                {userData.github && (
                    <a
                        href={userData.github}
                        target='_blank'
                        rel='noreferrer'
                    >
                        <FaGithub
                            className='landing--social'
                            style={{ color: props.color }}
                            aria-label='GitHub'
                        />
                    </a>
                )}
                {userData.email && (
                    <a
                        href={`mailto:${userData.email}`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        <FaEnvelope
                            className='landing--social'
                            style={{ color: props.color }}
                            aria-label='Email'
                        />
                    </a>
                )}

            </>
        )
    
}

export default Socials